import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
} from "reactstrap";
import { Droppable } from "react-beautiful-dnd";
import classnames from "classnames";
import { equals } from "ramda";
import footerIcons from "../../assets/home/footer-icons.svg";

import { ConfigurableDragableComponent } from "./wysiwyg-draggable-item";
import { AlwaysVisibleScrollArea } from "../shared/AlwaysVisibleScrollArea";
import { useTranslation } from "react-i18next";

export const WysiwygColumn = ({
  placedComponents,
  droppableId,
  selectedComponentUUID,
  onSelectComponent,
}) => {
  const { t } = useTranslation();
  return (
    <div className="wysiwyg-column">
      <Card
        className="main-card"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "85vh",
          maxHeight: "85vh",
          overflow: "hidden",
        }}
      >
        <div className="speaker" />
        <CardHeader
          className="phone-header"
          style={{ borderRadius: "40px 40px 0 0", backgroundColor: "white" }}
        />
        <CardBody
          className="components-container-shell"
          style={{
            position: "relative",
            flex: "1 1 0%",
            minHeight: 0,
            overflow: "hidden",
            padding: 0,
          }}
        >
          <AlwaysVisibleScrollArea className="avs--light components-container">
            <Droppable droppableId={droppableId}>
              {(provided, snapshot) => (
                <div
                  className={classnames("droppable", {
                    "dragged-over": snapshot.isDraggingOver,
                  })}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {placedComponents.map(({ uuid, ...componentItem }, idx) => (
                    <ConfigurableDragableComponent
                      key={`${uuid}_${componentItem.componentId}`}
                      idx={idx}
                      isSelected={equals(selectedComponentUUID, uuid)}
                      uuid={uuid}
                      onSelect={onSelectComponent}
                      {...componentItem}
                    />
                  ))}
                  {!placedComponents.length && (
                    <div className="phone-empty">{t("home.copyHomeEmpty")}</div>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </AlwaysVisibleScrollArea>
        </CardBody>
        <CardFooter className="footer-icons">
          <img src={footerIcons} alt="" />
        </CardFooter>
      </Card>
    </div>
  );
};
